// extracted by mini-css-extract-plugin
export default {"divMain":"Footer_divMain__3PTRG"};